<template>
<div class="sip_modal_btn_space_progress" >
  <div class="sip_modal_btn_space_progress_line" ref="spaceProgress" :style="`transform: translateX(${pers}%)`" />
  <img :src="`${$server}modal/space_progress_bg.png`" class="sip_modal_btn_space_progress_bg" />
</div>
</template>

<script>
export default {
  name: 'BtnProgress',
  data() {
    return {
    }
  },
  props: ['pers'],
  methods: {
    // progress() {
    //   let id = setInterval(()=>{
    //     if(this.pers > 0) {
    //       this.pers--
    //     }else{
    //       this.$emit('refill', true)
    //       this.pers = 90
    //       clearInterval(id)
    //     }
    //   },80)
    // }
  }
}
</script>

<style lang="stylus">
.sip_modal_btn_space
  position relative
  .sip_modal_btn_space_progress
    position: absolute
    top 0
    left 0
    right 0
    bottom 0
    background-color #4E737E
    border-radius 6px
    overflow hidden
    .sip_modal_btn_space_progress_line
      position: absolute
      top 0
      left 0
      width 100%
      height 100%
      background-color: #5BAF09
      transform translateX(-50%)
      border-top-right-radius 9px
      border-bottom-right-radius 9px
    .sip_modal_btn_space_progress_bg
      position: absolute
      top 0
      left 0
      width 100%
      height 100%
</style>